import Nr from "@/utils/NetworldRequest";
const request = new Nr().getAxios();
function getBaseUrl(serviceName) {
  return new Nr().getBaseUrl(serviceName);
}
export default {
  // 获取大区 省市
  getAreaInfo() {
    return request({
      url: `/jjt/dealer/region-list`,
      method: "get",
      baseURL: process.env.VUE_APP_OPENDATA_AGG_API,
    }).then((res) => {
      res = res.data;
      let list = [];
      if (res.data.type == 10) {
        list.push({
          id: "",
          name: "不限大区",
        });
      }
      list = list.concat(res.data.region_list);
      console.log(list);
      return {
        code: res.code,
        data: list,
        msg: res.msg,
      };
    });
  },
  // 获取全部分组
  getAllGroup() {
    return request({
      url: `/jjt/group/selectAllGroup`,
      method: "get",
      baseURL: process.env.VUE_APP_OPENDATA_AGG_API,
    }).then((res) => {
      res = res.data;
      return res;
    });
  },
  // 获取全部违规标签
  getMonitorTag(params) {
    return request({
      url: `/jjt/principal/illegal/tag`,
      method: "get",
      baseURL: process.env.VUE_APP_OPENDATA_AGG_API,
      params,
    }).then((res) => {
      res = res.data;
      return res;
    });
  },
  getVideoList({
    area_id,
    group_code,
    start_time,
    end_time,
    illegal_type,
    field,
    current,
    size,
    platform,
  }) {
    return request({
      url: `/jjt/aweme/illegal/surveillance`,
      method: "post",
      baseURL: getBaseUrl(platform),
      data: {
        area_id,
        group_code,
        start_time,
        end_time,
        illegal_type,
        field,
        current,
        size,
      },
    }).then((res) => {
      res = res.data;
      let newRes = {
        code: res.code,
        data: res.data,
        msg: res.msg,
      };
      return newRes;
    });
  },
  getVideoChart({
    area_id,
    group_code,
    start_time,
    end_time,
    illegal_type,
    field,
    current,
    size,
    platform,
  }) {
    return request({
      url: `/jjt/aweme/illegal/compare`,
      method: "post",
      baseURL: getBaseUrl(platform),
      data: {
        area_id,
        group_code,
        start_time,
        end_time,
        illegal_type,
        field,
        current,
        size,
      },
    }).then((res) => {
      res = res.data;
      let newRes = {
        code: res.code,
        data: {
          ...res.data,
          xData: res.data
            .map((item) => {
              return `近${item.week}周(${item.time})`;
            })
            .reverse(),
          aweme_count: res.data
            .map((item) => {
              return item.aweme_count;
            })
            .reverse(),
          aweme_count_compare: res.data
            .map((item) => {
              return item.aweme_count_compare || 0;
            })
            .reverse(),
        },
        msg: res.msg,
      };
      return newRes;
    });
  },

  // 修改tag
  editTags(data) {
    return request({
      url: `/jjt/aweme-monitor/update/tag`,
      method: "post",
      baseURL: getBaseUrl(data.platform),
      data,
    }).then((res) => {
      res = res.data;
      return res;
    });
  },
};
